import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { ListaVideosDrop } from '../../components/listaVideosDrop'
import { serverApi } from '../../api'
import { SelectElement } from '../../components/selectElement2'
import { CrearVideoModal } from './components/CrearVideoModal'


const MySwal = withReactContent(Swal);
// const sweet = ( title, html, icon ) =>{ MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000  }) }
const sweetConfirm = ( title, html, icon ) =>{  
    return MySwal.fire({ 
        title, 
        html, 
        icon, 
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',  
        showCancelButton: true, 
        cancelButtonColor: '#d33',  
        cancelButtonText: 'Cancelar' 
    }) 
}




export const VideosAdmin =  () => {

    const { socket } = useContext( SocketContext );
    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();
    const [showModal, setShowModal] = useState(false);
    
    
    const [ubicaciones, setUbicaciones ] = useState([]);

    const [ isLoading, setIsLoading ] = useState(false);
    const [items, setItems] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'eol',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: '',
        uidUsuario: ''
    });
    
    
    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate ])

    useHideMenu(false);

    //Select-ubicaciones
    useEffect( () => {
    
        const codigoEntidad = localStorage.getItem("codigoEntidad");
        
        if (!codigoEntidad) return;

        const fetch = async () => {
            try {
                
                setIsLoading(true);                    
                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad } );
                const opciones = resp.data.data.map( (item) => ( { value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data:item.codigoUbicacion } ) )
                setUbicaciones( opciones );

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );

                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetch();

    },[usuario])

    const handleSelectUbicacion = (selected) => {
        console.log(selected);
        
        setQuery(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
    };

    useEffect(() => {
        
        if (!socket) return;

        const handler = (lista) => {
            setItems(lista);
            console.log(lista);
        };

        socket.on('videos-lista', handler);

        return () => {
            socket.off('lista-modulos-tiposAtencion', handler);
        };

    }, [socket]);
       
    
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if ( !codigoEntidad || !codigoUbicacion ) return;

        const fetch = async () => {
            try {

                setIsLoading(true);                    
                const resp = await serverApi.post(`/videos/videos-lista`, 
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );
                setItems(resp.data.videosLista)
                
            } catch (error) {
                console.error("Error al obtener los usuarios", error);
            } finally {
                setIsLoading(false);                
            }
        };

        fetch();

    }, [query, usuario])


    const handleInputChange = async(ev, campo, uidVideo) => {

        const valorNuevo = ev.target.value.trim();

        // Buscar item actual
        const itemActual = items.find(
            item => item.uidVideo === uidVideo
        );

        if (!itemActual) return;

        // Valor anterior REAL desde state
        const valorAnterior = itemActual[campo];

        // Si no cambió
        if (valorNuevo === valorAnterior) {
            return;
        }
      
        
        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Modificar el registro?", "warning" );
        if (!confirmacion.value){
            ev.target.value = valorAnterior;
            return false;
        }

        try {
        
            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if( codigoEntidad === "" ) return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            await serverApi.post(
                `/videos/actualiza-registro`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    campo, uidVideo, valor: valorNuevo
                }
            );

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }

    };

    const onDragEnd = (result) => {
            if (!result.destination) return; // Si el elemento no se soltó en un destino válido, no hagas nada

            const updatedItems = Array.from(items);
            const [removed] = updatedItems.splice(result.source.index, 1); // Elimina el elemento de la posición de origen
            updatedItems.splice(result.destination.index, 0, removed); // Inserta el elemento en la posición de destino

            setItems(updatedItems);

            registraCambios(updatedItems);
    
    };

    const registraItem = async ( form ) => {

        try {
        
            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if( codigoEntidad === "" ) return;
            await serverApi.post(
                `/videos/registra-video`,
                {
                    ...query,
                    ...form,
                    codigoEntidad,
                    
                }
            );

            setShowModal(false);

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }
        

        

    }
    
    const registraCambios =  async (updatedItems) =>{


        try {
        
            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if( codigoEntidad === "" ) return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            await serverApi.post(
                `/videos/actualiza-videos`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    updatedItems
                }
            );

        } catch (error) {
            console.error("Error modificar listado", error);
        } finally {
            setIsLoading(false);
        }
    
    }

    const deleteItem = async(uidVideo) =>{
        console.log(uidVideo);

        const confirmacion = await sweetConfirm( "Atención", "Esta seguro de Eliminar el registro?", "warning" );
        if (!confirmacion.value){
            return false;
        }

        try {
        
            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if( codigoEntidad === "" ) return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            await serverApi.post(
                `/videos/borra-registro`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidVideo
                }
            );

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }

    } 

    


    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }
    else if( !pantallas.includes("videoslistas") ) {
        return( <NoAcceso /> )
    } 
    else{

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>

                    <div className='col-lg-2 col-12 '>
                        <button
                            className='btn btn-success m-3'
                            onClick={() => setShowModal(true)}
                        >
                            Agregar Video
                        </button>

                        <CrearVideoModal
                            show={showModal}
                            onClose={() => setShowModal(false)}
                            ubicaciones={ubicaciones} 
                            onSave={(datos) => registraItem(datos)}
                        />
                        
                    </div>

                    <hr />


                    <div className='col-12 col-md-4'>
                        
                        <div className='p-3'>
                            <label>Sede/ubicación</label>
                            <SelectElement
                                options= { ubicaciones }
                                name={ `idUbicacion`}
                                isMulti= {false}
                                closeOnMenuSelect= {true}
                                value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                onChange= {(selected) => handleSelectUbicacion(selected)}
                                classname= "form-control form-control-lg" 
                                isClearable = {false}
                            />
        
                        </div>
                    </div>

                    {/* <h1>Lista De Videos en la Pantalla Principal </h1> */}
                    <ListaVideosDrop items={items} onDragEnd={onDragEnd} handleInputChange={handleInputChange} deleteItem={deleteItem} />

                </div>

            </>
        );
    }

}